import { Link } from "react-router-dom";
import { Mail, MessageCircle } from "lucide-react";
import { useLang, CONTACT } from "@/lib/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-[#D4AF37]/30 bg-[#050B14]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-10 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <p className="font-display text-3xl tracking-[0.2em] text-[#D4AF37]">JOLLY ROGER LTD</p>
          <p className="text-sm text-slate-400 mt-3">{t.footer_area}</p>
        </div>
        <div className="space-y-3 text-sm">
          <p className="text-xs uppercase tracking-[0.25em] text-slate-500 mb-4">{t.footer_contact}</p>
          <a href={CONTACT.whatsappLink} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-link" className="flex items-center gap-3 hover:text-[#D4AF37] transition-colors duration-300">
            <MessageCircle className="w-4 h-4 text-[#D4AF37]" />WhatsApp : {CONTACT.whatsapp}
          </a>
          <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="flex items-center gap-3 hover:text-[#D4AF37] transition-colors duration-300">
            <Mail className="w-4 h-4 text-[#D4AF37]" />{CONTACT.email}
          </a>
        </div>
        <div className="md:text-right text-sm">
          <Link to="/admin" data-testid="footer-admin-link" className="text-slate-500 hover:text-[#D4AF37] transition-colors duration-300">{t.nav_admin}</Link>
          <p className="text-slate-600 mt-3">© {new Date().getFullYear()} Jolly Roger LTD</p>
        </div>
      </div>
    </footer>
  );
}
